export default "__VITE_ASSET__90042fe2__"